export const environment = {
    production: false,
    environment: 'development',
    api: 'http://localhost:8080',
    apikey: 'AAPKaa6b119b54a341e0b40063d7128300290cZ3LC7nVZpHTLc0fJUhENS_d3HxF1470G3OryiyshARR6srCDmyflyma87U4FSE'
  };